module.exports = __webpack_public_path__ + "static/media/hourglass.76d31092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/hourglass.svg
// module id = 735
// module chunks = 3